import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useAppThunkDispatch } from 'state/store';
import {
  myBoard,
  myBoardSearchParam,
  myBoardProcess,
  myBoardFilters,
  fetchUserProjects,
} from 'state/Projects/projectsSlice';
import { fetchFilterSettingByType } from 'state/Settings/Filters/FiltersSlice';
import { PROJECTS_BOARD_TABS, SETTINGS_FILTERS } from 'utils/constants';
import BoardHeader from './BoardHeader';
import EmptyBoard from './EmptyBoard';
import StagesList from './StagesList';

const MyBoard: FC<{ handleAddProject: () => void }> = ({
  handleAddProject,
}) => {
  const dispatch = useAppThunkDispatch();
  const myBoardStagesList = useSelector(myBoard);
  const myBoardSearch = useSelector(myBoardSearchParam);
  const emptyMyBoardFilters = isEmpty(useSelector(myBoardFilters));
  const selectedProcessId = useSelector(myBoardProcess);

  useEffect(() => {
    dispatch(fetchFilterSettingByType(SETTINGS_FILTERS.MY_PROJECTS_BOARD));
    dispatch(fetchUserProjects());
  }, [dispatch]);

  return (
    <div data-cy='my-board'>
      <BoardHeader
        boardTab={PROJECTS_BOARD_TABS.MY_BOARD}
        selectedProcessId={selectedProcessId}
        searchParam={myBoardSearch}
      />
      <StagesList
        stages={myBoardStagesList}
        areFiltersApplied={!emptyMyBoardFilters}
        emptyComponent={
          <EmptyBoard
            handleAddProject={handleAddProject}
            isSearchEmpty={isEmpty(myBoardSearch)}
            isFiltersEmpty={emptyMyBoardFilters}
          />
        }
      />
    </div>
  );
};

export default MyBoard;
